"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AGGREGATE_FUNCTION_KEYS = exports.AggregateFunctionType = void 0;
var AggregateFunctionType;
(function (AggregateFunctionType) {
    AggregateFunctionType["AVERAGE"] = "Average";
    AggregateFunctionType["COUNT"] = "Count";
    AggregateFunctionType["MAXIMUM"] = "Maximum";
    AggregateFunctionType["MEDIAN"] = "Median";
    AggregateFunctionType["MINIMUM"] = "Minimum";
    AggregateFunctionType["SUM"] = "Sum";
})(AggregateFunctionType = exports.AggregateFunctionType || (exports.AggregateFunctionType = {}));
exports.AGGREGATE_FUNCTION_KEYS = new Map(Object.entries(AggregateFunctionType).map(([k, v]) => [
    v,
    k,
]));
